import { createApp, SetupContext } from 'vue'
import App from './App.vue'
import messages from './i18n'

const i18n = window.VueI18n.createI18n({
    locale: window.config.getLang(),
    fallbackLocale: 'cz',
    messages,
})

export const mount = (props: SetupContext['attrs']): void => {
    const app = createApp(App, props)
    app.use(i18n)
    app.mount('#vue-megamenu')
}
